import { BaseLoadingStore } from "app/modules/common/stores/BaseLoadingStore";
import { action, makeObservable, observable, runInAction } from "mobx";
import { inject } from "react-ioc";
import { NavigationStore } from "app/modules/company/stores/NavigationStore";
import { ApiClients, apiBaseUrl } from "app/modules/company/services/AxiosBaseClient";
import { IUserInfo, TenantClaims, ITenantInfo } from "app/modules/company/api/clients.api";
import { PusherTenantService } from "app/modules/common/pusher/PusherTenantService";
import { FeatureFlagsService } from "app/stores/FeatureFlagsService";

export class MainStore extends BaseLoadingStore {
    @inject apiClients: ApiClients;
    @inject navigationStore: NavigationStore;
    @inject pusherTenantService: PusherTenantService;
    @inject featureFlagsService: FeatureFlagsService;

    userData: IUserInfo = null;
    tenantData: ITenantInfo = null;

    isAuthenticated: boolean = false;

    constructor() {
        super();

        makeObservable(this, {
            userData: observable,
            isAuthenticated: observable,

            init: action
        });
    }

    checkClaim = (claim: TenantClaims) => (this.userData.isAdmin || this.userData.claims.find(x => x == claim) || this.userData.claims.find(x => x == TenantClaims.FullAccess)) != null;

    switchTenant = async (tenantId: number) => {
        await this.apiClients.userClient.selectTenant(tenantId);
        window.location.reload();
    }

    async init() {
        await this.wrapInitLoadingApiCall(async () => {
            [this.userData, this.tenantData] = await Promise.all([
                await this.apiClients.tenantDataProviderClient.getUserData(),
                await this.apiClients.tenantDataProviderClient.getTenantData()
            ]);

            let authEndpoint = this.userData.pusherSettings.channelAuthorization || "";
            try {
                const apiOrigin = new URL(apiBaseUrl).origin;
                const authUrl = new URL(authEndpoint);
                if (authUrl.origin !== apiOrigin) authEndpoint = apiOrigin + authUrl.pathname;
            } catch { if (authEndpoint) authEndpoint = apiBaseUrl.replace(/\/$/, "") + (authEndpoint.startsWith("/") ? authEndpoint : "/" + authEndpoint); }
            if (!authEndpoint) authEndpoint = apiBaseUrl.replace(/\/$/, "") + "/company/Pusher/Auth";

            this.pusherTenantService.init(
                this.userData.pusherSettings.appKey,
                this.userData.pusherSettings.cluster,
                this.userData.pusherSettings.pusherNamespace,
                authEndpoint,
                this.userData.tenantId);

            this.isAuthenticated = true;

            await this.featureFlagsService.updateContext({
                userId: this.userData.userEmail,
                properties: {
                    tenantId: this.userData.tenantId?.toString()
                },
            });

            await this.navigationStore.init(this.checkClaim);
        }, null, () => {
            runInAction(() => {
                this.isInitLoading = false;
            });
        });

        /*spy((event) => {
            if (event.type === 'update') {
                console.log(event)
            }
        })*/
    }
}
